import { CustomEventWithDetail } from 'rune-ts';
import { ARTICLE_TYPES } from '../../../../../../../modules/MShop/App/Store/Community/S/Constant/community';

export class FanLetterFormTextAreaInputEvent extends CustomEventWithDetail<{
  value_length: number;
  is_over_min_count: boolean;
}> {}

export class FanLetterFormTextAreaFocusEvent extends CustomEventWithDetail<{
  focus: boolean;
}> {}

export class FanLetterFormFileChangeEvent extends CustomEventWithDetail<{
  is_over_max_count: boolean;
}> {}

export class FanLetterFormSubmitEvent extends CustomEventWithDetail<{
  type: keyof typeof ARTICLE_TYPES;
}> {}

export class FanLetterFormImageDeleteEvent extends CustomEventWithDetail<{
  file_id: number;
}> {}
